import script from "./DoB.vue?vue&type=script&setup=true&lang=ts"
export * from "./DoB.vue?vue&type=script&setup=true&lang=ts"

import "./DoB.vue?vue&type=style&index=0&id=260ec764&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-260ec764"]])

export default __exports__